import React, {useContext, useEffect, useState} from 'react';
import { Field } from 'react-final-form';
import MuiButton from "@material-ui/core/Button";

import RadioButton from './RadioBig';
import Grid from "@material-ui/core/Grid";
import Select from "./Select";
import TextInput from "./TextInput";
import styled from "styled-components";
import SelectCard from "./SelectCard";
import {getCookieValue} from "../utils/getCookieValue";

import { Trans } from "../utils/i18n";
import HelpModal from "./HelpModal";
import {useFormState, useFormStateDispatch} from "../FormComponents/FormState";
import {Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import dayjs from "dayjs";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import {InertiaLink, usePage} from "@inertiajs/inertia-react";
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import {last} from "lodash";
import {useMutation} from "@tanstack/react-query";


const ProductItem = styled.div`
    transition: background-color .2s,color .2s;
    border-radius: 5px;
`;


const TerminalID = React.memo(function ({ values, form, addCompany, addCoverageId, setAddressId, uppercase, }) {
    const orderEntryDispatch = useFormStateDispatch();
    const { terminalId } = useFormState();

    const checkTerminalId = useMutation({
        mutationFn: newTodo => axios.post(route('order.terminalid'), newTodo),
    });

    const onEnter = (event) => {
        if(!values.terminalId) {
            return;
        }
        checkTerminalId.mutate({
            terminalId: values.terminalId,
        }, {
            onSuccess: (data) => {
                if(!data?.data?.success) {
                    throw data;
                }

                orderEntryDispatch({ type: 'setTerminalId', value: data?.data });
                if(data?.data?.defaultAddress?.phone) {
                    form.change('phone', data?.data?.defaultAddress?.phone)
                }
                if(data?.data?.defaultAddress?.email) {
                    form.change('email', data?.data?.defaultAddress?.email)
                }
                if(data?.data?.defaultAddress?.name) {
                    form.change('name', data?.data?.defaultAddress?.name)
                }
            },
            onError: (errorResponse) => {
                orderEntryDispatch({ type: 'setTerminalId', value: {} });
                addCompany(null);
                addCoverageId(null);
                setAddressId(null);
            }
        })
        event.preventDefault();
    };

    return (
        <div>
            <div className={'flex gap-3 items-start max-w-xl'}>
                <div className={'flex-1'}>
                    <Field
                        name={'terminalId'}
                        type={'text'}
                        component={TextInput}
                        validate={value => {
                            return (value ? undefined : <Trans i18nKey="serialNumber.required">Required</Trans>);
                        }}
                        field={{
                            label: <Trans i18nKey="orderEntry.terminalId.label">Terminal ID</Trans>,
                            type: uppercase ? 'uppercase' : undefined,
                        }}
                        onEnter={onEnter}
                        disabled={ checkTerminalId.isSuccess}
                    />
                </div>
                {
                    !checkTerminalId.isSuccess &&
                    <MuiButton
                        variant="contained"
                        color={'secondary'}
                        onClick={onEnter}
                        id={'serialnumber-search'}
                        size={'large'}
                        styled={{ padding: '14px 22px', }}
                    >
                        <Trans i18nKey="serialNumber.search">Search</Trans>
                    </MuiButton>
                }
                {
                    checkTerminalId.isSuccess &&
                    <MuiButton
                        variant="contained"
                        color={'secondary'}
                        onClick={() => {
                            orderEntryDispatch({ type: 'setTerminalId', value: {} });
                            checkTerminalId.reset();
                            addCompany(null);
                            addCoverageId(null);
                            setAddressId(null);
                        }}
                        id={'serialnumber-search'}
                        size={'large'}
                        styled={{ padding: '14px 22px', }}
                        startIcon={<ChangeCircleIcon />}
                    >
                        <Trans i18nKey="serialNumber.change">Change</Trans>
                    </MuiButton>
                }
            </div>
            {
                !!checkTerminalId?.isError && (
                    <div className={'flex justify-center mt-6'}>
                        <div className={'p-6 max-w-2xl b2x-shadow-md rounded-lg mt-3 flex flex-col justify-center items-center gap-1 bg-red-100 text-center'}>
                            <h3 className={'font-bold text-lg m-0'}>
                                { checkTerminalId?.error?.response?.data?.message || <Trans i18nKey="common.error">An error occurred</Trans> }
                            </h3>
                        </div>
                    </div>
                )
            }
            {
                checkTerminalId.isSuccess &&
                <div>
                    <div>
                        <h3 className={'h3 mt-9'}><Trans i18nKey="common.orderFound">We have found your order</Trans></h3>
                    </div>
                </div>
            }
        </div>
    );
},
function areEqual(prevProps, nextProps) {
    return JSON.stringify(prevProps) === JSON.stringify(nextProps);
});

export default TerminalID;
